module.exports = __webpack_public_path__ + "01618e2d62107618a41e0de3e27ae83a.pdf";